import { getEmailBackendBaseUrl } from '@/config/api';
import { fetchPolicyPdfBlob, fetchQuotePdfBlob } from '@/services/quotePdfService';
import { mapFormaPago, mapPaquete, mapIdCia } from '@/utils/emissionMappers';
import type { Documento } from './types';

// Small pause between files so the browser does not block consecutive downloads.
const DOCUMENT_DOWNLOAD_DELAY_MS = 500;

export interface QuoteSelection {
  selectedPaymentMethod: string;
  selectedPlanType: string;
  selectedCompany?: string;
}

export const documentDownloadUrl = (guidDocumento: string): string =>
  `${getEmailBackendBaseUrl()}/api/email/download/document/${guidDocumento}`;

export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

const downloadDocument = async (doc: Documento): Promise<void> => {
  if (!doc.Guid_Documento) return;

  const docUrl = documentDownloadUrl(doc.Guid_Documento);
  console.log('📥 Descargando documento:', docUrl);

  const docResponse = await fetch(docUrl);
  if (!docResponse.ok) {
    console.warn(`⚠️ Error al descargar documento ${doc.Nombre}: ${docResponse.statusText}`);
    return;
  }

  const docBlob = await docResponse.blob();
  downloadBlob(docBlob, doc.Nombre || `Documento-${doc.Guid_Documento}.pdf`);
  await new Promise(resolve => setTimeout(resolve, DOCUMENT_DOWNLOAD_DELAY_MS));
};

/** Download the policy PDF and then each document, one after another. */
export const downloadPolicyBundle = async (idPoliza: number, documentos?: Documento[] | null): Promise<void> => {
  const pdfBlob = await fetchPolicyPdfBlob(idPoliza);
  downloadBlob(pdfBlob, `Poliza-${idPoliza}.pdf`);

  for (const doc of documentos ?? []) {
    await downloadDocument(doc);
  }
};

export const downloadQuotePdf = async (idCotizacion: number | string, selection: QuoteSelection): Promise<void> => {
  const pdfBlob = await fetchQuotePdfBlob({
    idCotizacion,
    formaPago: mapFormaPago(selection.selectedPaymentMethod),
    paquete: mapPaquete(selection.selectedPlanType),
    cia: mapIdCia(selection.selectedCompany),
  });
  downloadBlob(pdfBlob, `Cotizacion-${idCotizacion}.pdf`);
};
